/**
 * Find an Object inside a nested Object based on a String.
 * @param {object} object The Object to search through.
 * @param {string} target The Key in which the String should be located.
 * @param {string} value The String to search for.
 * @returns {object || undefined} The isolated Object, if the String was located.
 */
function getObject(object, target, value) {
  let result;
  if (!object || typeof object !== 'object') return undefined;
  Object.keys(object).some((key) => {
    if (key === target && object[key] === value) return (result = object);
    return (result = getObject(object[key], target, value));
  });
  return result;
}

export default getObject;
